// src/pages/ClienteBio.jsx
import { useCliente } from "../hooks/useCliente";
import { authFetch } from "../utils/authFetch";
import StoricoConsumiModal from "../components/StoricoConsumiModal";
// import StoricoPagamentiModal from "../components/StoricoPagamentiModal"; // rimosso
import StoricoPuntiModal from "../components/StoricoPuntiModal";
import StoricoWalletModal from "../components/StoricoWalletModal";
import SezionePunti from "../components/SezionePunti";
import AnagraficaCliente from "../components/AnagraficaCliente";
import WalletClienteBox from "../components/WalletClienteBox";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

const ClienteBio = () => {
  const { id } = useParams();
  const token = localStorage.getItem("access");

  const {
    cliente,
    prodotti,
    storicoPunti,
    fetchCliente,
    fetchStoricoPunti,
    fetchStoricoConsumi,
  } = useCliente(id);

  const [prodottoAcquisto, setProdottoAcquisto] = useState("");
  const [quantitaAcquisto, setQuantitaAcquisto] = useState("");
  const [righeAcquisto, setRigheAcquisto] = useState([]);
  const [scaricaPunti, setScaricaPunti] = useState("");
  const [motivoScarico, setMotivoScarico] = useState("");
  const [migrazioneQty075, setMigrazioneQty075] = useState("");
  const [migrazioneQty1, setMigrazioneQty1] = useState("");
  const [migrazioneInCorso, setMigrazioneInCorso] = useState(false);
  const [messaggio, setMessaggio] = useState("");
      
  const [showStoricoPunti, setShowStoricoPunti] = useState(false);
  const [showStoricoConsumi, setShowStoricoConsumi] = useState(false);
  const [showStoricoWallet, setShowStoricoWallet] = useState(false);
  const [walletRefreshKey, setWalletRefreshKey] = useState(0);

  // Pagamenti (usati dallo storico consumi)
  const [pagamento, setPagamento] = useState("");
  const [pagamentoData, setPagamentoData] = useState(""); // YYYY-MM-DD
  const [pagamentoOra, setPagamentoOra] = useState("");   // HH:MM

  if (!token) {
    return <p className="text-danger">🔒 Accesso non autorizzato. Effettua il login.</p>;
  }

  const aggiungiRigaAcquisto = () => {
    if (!prodottoAcquisto) {
      setMessaggio("❌ Seleziona un prodotto dal listino clienti.");
      return;
    }

    const qty = Number(quantitaAcquisto || 0);
    if (!qty || qty <= 0) {
      setMessaggio("❌ Inserisci una quantità valida.");
      return;
    }

    const prod = (prodotti || []).find((p) => String(p.id) === String(prodottoAcquisto));
    if (!prod) {
      setMessaggio("❌ Prodotto non trovato nel listino.");
      return;
    }

    setRigheAcquisto((prev) => [
      ...prev,
      {
        product_id: prod.id,
        product_name: prod.name,
        quantity: qty,
        prezzo: Number(prod.prezzo || 0),
        unit_type: prod.unit_type,
        litri_per_unita: Number(prod.litri_per_unita || 0),
      },
    ]);

    setProdottoAcquisto("");
    setQuantitaAcquisto("");
    setMessaggio("");
  };

  const rimuoviRigaAcquisto = (index) => {
    setRigheAcquisto((prev) => prev.filter((_, i) => i !== index));
  };

  const inviaConsumo = async () => {
    if (!righeAcquisto.length) {
      setMessaggio("❌ Aggiungi almeno una riga acquisto.");
      return;
    }

    const res = await authFetch(`${API_URL}/api/clienti/${id}/acquisto/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: righeAcquisto.map((r) => ({
          product_id: r.product_id,
          quantity: r.quantity,
        })),
      }),
    });
    const json = await res.json();

    if (res.ok) {
      setMessaggio(`✅ Acquisto completo registrato. Punti caricati: ${Number(json.punti_caricati || 0).toFixed(2)}.`);
      setRigheAcquisto([]);
      setProdottoAcquisto("");
      setQuantitaAcquisto("");
      fetchCliente();
      fetchStoricoPunti();
      fetchStoricoConsumi();
      setWalletRefreshKey((v) => v + 1);
    } else {
      setMessaggio(json.detail || "❌ Errore registrazione acquisto.");
    }
  };

  const totaleCarrello = () =>
    righeAcquisto.reduce(
      (sum, r) => sum + Number(r.prezzo || 0) * Number(r.quantity || 0),
      0
    );

  const inviaPagamentoWallet = async () => {
    if (!righeAcquisto.length) {
      setMessaggio("❌ Aggiungi almeno una riga acquisto.");
      return;
    }

    const amount = Number(totaleCarrello().toFixed(2));

    if (!Number.isFinite(amount) || amount <= 0) {
      setMessaggio("❌ Totale acquisto non valido.");
      return;
    }

    const ok = window.confirm(
      `Confermi pagamento con App / Wallet di €${amount.toFixed(2)}? Il totale definitivo sarà verificato dal server.`
    );
    if (!ok) return;

    try {
      const res = await authFetch(
        `${API_URL}/api/clienti/${id}/acquisto-wallet/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: righeAcquisto.map((r) => ({
              product_id: r.product_id,
              quantity: r.quantity,
            })),
          }),
        }
      );

      const json = await res.json();

      if (!res.ok) {
        setMessaggio(json.detail || "❌ Acquisto Wallet non completato.");
        return;
      }

      window.dispatchEvent(new Event("dzr-wallet-refresh"));

      setMessaggio(
        `✅ Acquisto #${json.consumption_id} pagato con App: €${Number(json.total_amount || 0).toFixed(2)}. Punti caricati: ${Number(json.punti_caricati || 0).toFixed(2)}.`
      );

      setRigheAcquisto([]);
      setProdottoAcquisto("");
      setQuantitaAcquisto("");
      fetchCliente();
      fetchStoricoPunti();
      fetchStoricoConsumi();
      setWalletRefreshKey((v) => v + 1);
    } catch (error) {
      console.error("Errore acquisto Wallet:", error);
      setMessaggio(
        "❌ Impossibile verificare l'esito dell'acquisto Wallet. Controlla lo storico prima di riprovare, per evitare duplicazioni."
      );
    }
  };

  const toggleMarketingCliente = async () => {
    if (!cliente?.code) return;

    const nextValue = !cliente?.marketing_consent;
    const ok = window.confirm(
      nextValue
        ? "Confermi di abilitare il cliente alla ricezione di promozioni e offerte?"
        : "Confermi di disabilitare il cliente dalla mailing list promozionale?"
    );
    if (!ok) return;

    const res = await authFetch(`${API_URL}/api/clienti/${cliente.code}/marketing/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ marketing_consent: nextValue }),
    });

    const json = await res.json().catch(() => ({}));

    if (res.ok) {
      setMessaggio(nextValue ? "✅ Marketing abilitato." : "✅ Marketing disabilitato.");
      fetchCliente();
    } else {
      setMessaggio(json.detail || "❌ Errore aggiornamento consenso marketing.");
    }
  };

  const verificaEtaCliente = async () => {
    if (!cliente?.code) return;

    const ok = window.confirm("Confermi di aver verificato il documento e la maggiore età del cliente?");
    if (!ok) return;

    const res = await authFetch(`${API_URL}/api/clienti/${cliente.code}/verifica-eta/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    const json = await res.json().catch(() => ({}));

    if (res.ok) {
      setMessaggio("✅ Età cliente verificata.");
      fetchCliente();
    } else {
      setMessaggio(json.detail || "❌ Errore verifica età cliente.");
    }
  };

  const chiudiAccountApp = async () => {
    if (!cliente?.code) return;

    const conferma1 = window.confirm(
      `Confermi di voler chiudere l'account App di ${cliente?.name || cliente?.email || "questo cliente"}?`
    );

    if (!conferma1) return;

    const conferma2 = window.confirm(
      "ATTENZIONE: l'accesso all'App verrà disattivato. Eventuali bonus o crediti promozionali decadono con la chiusura dell'account. Prima di procedere verifica che l'eventuale credito derivante da ricariche effettuate con denaro sia già stato gestito. Vuoi continuare?"
    );

    if (!conferma2) return;

    const res = await authFetch(
      `${API_URL}/api/clienti/${cliente.code}/chiudi-account-app/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );

    const json = await res.json().catch(() => ({}));

    if (res.ok) {
      alert(
        json.detail ||
          "Account App chiuso correttamente. L'accesso all'App ? stato disattivato."
      );
      window.location.href = "/clienti";
    } else {
      setMessaggio(
        json.detail || "? Errore durante la chiusura dell'account App."
      );
    }
  };

  const inviaMigrazioneTessera = async () => {
    if (!cliente?.code) {
      setMessaggio("Cliente non caricato correttamente.");
      return;
    }

    const qty075 = Number(migrazioneQty075 || 0);
    const qty1 = Number(migrazioneQty1 || 0);
    const punti = (qty075 * 0.75) + qty1;

    if (qty075 < 0 || qty1 < 0 || (qty075 <= 0 && qty1 <= 0)) {
      setMessaggio("Inserisci almeno una quantit? valida da migrare.");
      return;
    }

    const ok = window.confirm(
      `Confermi la migrazione della tessera precedente?\n\n` +
      `${qty075} x 0,75 L + ${qty1} x 1 L\n` +
      `Punti da migrare: ${punti.toFixed(2)}\n\n` +
      `Questa operazione NON registra una nuova vendita.`
    );

    if (!ok) return;

    setMigrazioneInCorso(true);

    try {
      const res = await authFetch(
        `${API_URL}/api/clienti/${cliente.code}/punti/migra-tessera-precedente/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            qty_075: qty075,
            qty_1: qty1,
          }),
        }
      );

      const json = await res.json().catch(() => ({}));

      if (res.ok) {
        setMessaggio(
          `Migrazione completata. ${Number(json.punti_migrati || punti).toFixed(2)} punti aggiunti al cliente.`
        );
        setMigrazioneQty075("");
        setMigrazioneQty1("");
        fetchCliente();
        fetchStoricoPunti();
      } else {
        setMessaggio(json.detail || "Errore durante la migrazione della tessera precedente.");
      }
    } catch (error) {
      setMessaggio("Errore di comunicazione durante la migrazione della tessera precedente.");
    } finally {
      setMigrazioneInCorso(false);
    }
  };


  const inviaScaricoPunti = async () => {
    if (!cliente?.code) return alert("⚠️ Cliente non caricato correttamente.");
    const res = await authFetch(`${API_URL}/api/clienti/${cliente.code}/punti/scarica/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" }, // 👈 aggiunta
      body: JSON.stringify({ punti: scaricaPunti, reason: motivoScarico }),
    });
    const json = await res.json();
    if (res.ok) {
      setMessaggio(`✅ ${scaricaPunti} punti tolti.`);
      setScaricaPunti("");
      setMotivoScarico("");
      fetchCliente();
    } else {
      setMessaggio(json.detail || "❌ Errore scarico.");
    }
  };

  

  

  // Pagamento con datetime ISO (default 12:00 se manca l’ora)
  const inviaPagamento = async () => {
    if (!pagamento || isNaN(pagamento) || Number(pagamento) <= 0) {
      alert("❌ Inserisci un importo valido.");
      return;
    }

    const payload = { amount: Number(pagamento) };

    if (pagamentoData) {
      const hhmm = pagamentoOra && /^\d{2}:\d{2}$/.test(pagamentoOra) ? pagamentoOra : "12:00";
      const iso = `${pagamentoData}T${hhmm}:00`;
      payload.datetime = iso;
      payload.date = iso; // retrocompatibilità
    }

    const res = await authFetch(`${API_URL}/api/clienti/${id}/pagamento/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" }, // 👈 aggiunta
      body: JSON.stringify(payload),
    });

    const json = await res.json();
    if (res.ok) {
      alert("✅ Pagamento registrato!");
      setPagamento("");
      setPagamentoData("");
      setPagamentoOra("");
      fetchCliente();
      fetchStoricoConsumi();
    } else {
      alert(json.detail || "❌ Errore pagamento.");
    }
  };

  
  const fmtDateTime = (v) => {
    if (!v) return "-";
    try {
      return new Date(v).toLocaleString("it-IT");
    } catch {
      return v;
    }
  };

  return (
    <div className="container mt-4">
      {cliente && (
        <>
            <AnagraficaCliente
              cliente={cliente}
              onStoricoPunti={() => {
                fetchStoricoPunti();
                setShowStoricoPunti(true);
              }}
              onStoricoConsumi={() => {
                fetchStoricoConsumi();
                setShowStoricoConsumi(true);
              }}
                onStoricoWallet={() => setShowStoricoWallet(true)}
              onClienteAggiornato={fetchCliente}
            />
              {cliente?.registered_from_app && (
                <div className="card shadow-sm border-0 mt-3">
                  <div className="card-body">
                    <h5 className="mb-3">🔞 Tutela App / Vendita Alcolici</h5>

                    <div className="row g-2">
                      <div className="col-md-6">
                        <strong>Maggiorenne confermato:</strong><br />
                        {cliente?.is_adult_confirmed ? "✅ SI" : "❌ NO"}
                      </div>

                      <div className="col-md-6">
                        <strong>Data di nascita:</strong><br />
                        {cliente?.birth_date || "-"}
                      </div>

                      <div className="col-md-6">
                        <strong>Privacy accettata:</strong><br />
                        {cliente?.privacy_accepted_at ? "✅ SI" : "❌ NO"}
                      </div>

                      <div className="col-md-6">
                        <strong>Termini accettati:</strong><br />
                        {cliente?.terms_accepted_at ? "✅ SI" : "❌ NO"}
                      </div>

                      <div className="col-md-6">
                        <strong>Condizioni vendita alcolici:</strong><br />
                        {cliente?.alcohol_policy_accepted_at ? "✅ SI" : "❌ NO"}
                      </div>

                      <div className="col-md-6">
                        <strong>Marketing:</strong><br />
                        {cliente?.marketing_consent ? "✅ SI" : "❌ NO"}<br />
                        <button
                          type="button"
                          className={`btn btn-sm mt-2 ${cliente?.marketing_consent ? "btn-outline-danger" : "btn-outline-success"}`}
                          onClick={toggleMarketingCliente}
                        >
                          {cliente?.marketing_consent ? "Disabilita marketing" : "Abilita marketing"}
                        </button>
                      </div>

                      <div className="col-md-6">
                        <strong>Registrato da app:</strong><br />
                        ✅ SI
                      </div>

                      <div className="col-md-6">
                        <strong>Data registrazione:</strong><br />
                        {fmtDateTime(cliente?.created_at)}
                      </div>

                      <div className="col-md-6">
                        <strong>Età/documento verificato:</strong><br />
                        {cliente?.age_verified ? "✅ SI" : "❌ NO"}
                      </div>

                      <div className="col-md-6">
                        <strong>Data verifica:</strong><br />
                        {fmtDateTime(cliente?.age_verified_at)}
                      </div>
                    </div>

                    {!cliente?.age_verified && (
                      <button
                        type="button"
                        className="btn btn-warning mt-3"
                        onClick={verificaEtaCliente}
                      >
                        ✅ Verifica età / documento
                      </button>
                    )}

                    {cliente?.age_verified && (
                      <div className="alert alert-success mt-3 mb-0">
                        Cliente abilitato agli acquisti online di prodotti alcolici.
                      </div>
                    )}

                    <hr className="my-4" />

                    <div className="border border-danger rounded-4 p-3">
                      <h6 className="fw-bold text-danger mb-2">
                        Account App
                      </h6>

                      <div className="small text-muted mb-3">
                        Usa questa funzione solo dopo aver verificato la richiesta di eliminazione del cliente e l'eventuale saldo Wallet.
                      </div>

                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={chiudiAccountApp}
                      >
                        🗑 Chiudi account App
                      </button>
                    </div>
                  </div>
                </div>
              )}

          <hr />
            <WalletClienteBox key={walletRefreshKey} clientCode={cliente.code} refreshKey={walletRefreshKey} />
        </>
      )}

      <SezionePunti
          prodotti={prodotti}
          prodottoAcquisto={prodottoAcquisto}
          quantitaAcquisto={quantitaAcquisto}
          righeAcquisto={righeAcquisto}
          scaricaPunti={scaricaPunti}
          motivoScarico={motivoScarico}
          migrazioneQty075={migrazioneQty075}
          migrazioneQty1={migrazioneQty1}
          migrazioneInCorso={migrazioneInCorso}
          messaggio={messaggio}
          setProdottoAcquisto={setProdottoAcquisto}
          setQuantitaAcquisto={setQuantitaAcquisto}
          aggiungiRigaAcquisto={aggiungiRigaAcquisto}
          rimuoviRigaAcquisto={rimuoviRigaAcquisto}
          setScaricaPunti={setScaricaPunti}
          setMotivoScarico={setMotivoScarico}
          setMigrazioneQty075={setMigrazioneQty075}
          setMigrazioneQty1={setMigrazioneQty1}
          inviaMigrazioneTessera={inviaMigrazioneTessera}
          inviaConsumo={inviaConsumo}
          inviaPagamentoWallet={inviaPagamentoWallet}
          inviaScaricoPunti={inviaScaricoPunti}
        />

{showStoricoPunti && (
        <StoricoPuntiModal
          storicoPunti={storicoPunti}
          onClose={() => setShowStoricoPunti(false)}
        />
      )}

        {showStoricoConsumi && (
          <StoricoConsumiModal
            mode="acquisti"
            clientCode={cliente.code}
            onClose={() => setShowStoricoConsumi(false)}
            pagamento={pagamento}
            setPagamento={setPagamento}
            pagamentoData={pagamentoData}
            setPagamentoData={setPagamentoData}
            pagamentoOra={pagamentoOra}
            setPagamentoOra={setPagamentoOra}
            inviaPagamento={inviaPagamento}
          />
        )}

          {showStoricoWallet && cliente && (
            <StoricoWalletModal
              clientCode={cliente.code}
              onClose={() => setShowStoricoWallet(false)}
            />
          )}

      
    </div>
  );
};

export default ClienteBio;
